import { Module } from '@nestjs/common';
import { SuggestionsController } from './suggestions.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SuggestionsAdapter } from './dto/suggestions.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { SuggestionsService } from './suggestions.service';
import { Suggestions } from './suggestions.entity';
@Module({
  imports: [
    TypeOrmModule.forFeature([Suggestions]),
  ],
  controllers: [SuggestionsController],
  providers: [SuggestionsService, SuggestionsAdapter, ApplicationExceptionHandler],
  exports: [SuggestionsService]
})
export class SuggestionsModule {}
